import { resourcesGridSliceSelector } from "../resourcesGridSliceSelector";
import { ResourcesGridType } from "../../utils/types/common";
import { RootState } from "@/store/store";

export const gridByIdSelector = (
  state: RootState,
  gridId: string,
): ResourcesGridType | null => {
  const slice = resourcesGridSliceSelector(state);

  return slice.grids?.[gridId] ?? null;
};
